package br.com.heyagenda.domain.model

enum class AppointmentStatus(val label: String) {
    CONFIRMED("Confirmado"),
    IN_PROGRESS("Em Atendimento"),
    COMPLETED("Concluído"),
    CANCELED("Cancelado"),
    NO_SHOW("Não Compareceu")
}

data class Appointment(
    val id: String,
    val clientName: String,
    val clientPhone: String? = null,
    val serviceName: String,
    val date: String = "",
    val startTime: String,
    val endTime: String,
    val priceFormatted: String,
    val status: AppointmentStatus = AppointmentStatus.CONFIRMED,
    val paymentMethod: String = "",
    val notes: String? = null,
    val startUtcIso: String = "",
    val endUtcIso: String = ""
)
